export default __webpack_public_path__ + "static/media/DragHandle.ea05aad4.svg";